import * as React from 'react';
// import { productType } from 'src/infrastructure/ProductType';
import { IDocument} from 'src/infrastructure/interfaces';

export interface ITypeImage {
  document: IDocument | null;
  data: any;
  isEditorView: boolean;
}

export default class TypeImage extends React.Component<ITypeImage> {
  constructor(props: ITypeImage) {
    super(props);
  }
  render() {
    
    if(this.props.data.src == null) {
      var image = this.props.data.image_path;
    }
    else {
      var image = this.props.data.src;
    }
    // HACK: Lines on notes aren't consistent height. Replace with an image.
    if (image === 'note') {
      image = "images/Blank/Notes-filler-pg.svg";
    }

   const url: string | null = this.props.data.url
    return ((url == null) || (url.length == 0))
      ?
      (<div className="page-placeholder-image-container">
        <img className="crop-page-drop-images" src={image} />
   
      </div>
      )
      :
      (<div className="page-placeholder-image-container">
        <a href={this.props.data.url}>
          <img className="crop-page-drop-images" src={image} />
        </a>
      </div>
      );
  }

}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageTypes/TypeImage.tsx